import React, { Component } from 'react';
import { config } from '../../../../../Configurations';
import screenWidthProvider from '../../../HOCS/ScreenWidthProvider';
import { ResponsiveGridContainer, ItemContainer, TextContainer, BdIcon } from './style';
import { Text } from '../../../../UI/Text';
import { roundNumber } from '../../../../../Utils';

class Programme extends Component {
    state = {
        iconSize: null,
        fontSize: null,
    };

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.getDimensions();
    }

    handleResize = () => {
        this.getDimensions();
    };

    getDimensions() {
        const { breakDowns } = this.props;

        const clientWidth = document.documentElement.clientWidth;
        const innerWidth = window.innerWidth;

        const clientHeight = document.documentElement.clientHeight;
        const innerHeight = window.innerHeight;

        const numberOfElements = Object.keys(breakDowns).length;

        const width = Math.max(clientWidth, innerWidth || 0);
        const height = Math.max(clientHeight, innerHeight || 0);
        const displayArea = width * (height - 200);

        let iconSize = 0;

        if (numberOfElements === 1) iconSize = roundNumber(Math.sqrt(displayArea / numberOfElements) / 2, 0);
        else iconSize = roundNumber(Math.sqrt(displayArea / numberOfElements) / 1.6, 0);

        const fontSize = roundNumber(iconSize / 10, 0);

        this.setState({ iconSize, fontSize });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    render() {
        const { iconSize, fontSize } = this.state;
        const { breakDowns } = this.props;

        return (
            <ResponsiveGridContainer>
                {Object.values(breakDowns).map((set, index) => (
                    <ItemContainer key={`programme-${index}`}>
                        <BdIcon src={`${config.baseUrl}/${set.exercise.orangeImage}`} size={iconSize} />
                        <TextContainer size={iconSize}>
                            <Text alignCenter={true} fontSize={fontSize}>
                                {set.count} {set.count === 1 ? 'set' : 'sets'} of {set.exercise.exerciseName}
                            </Text>
                        </TextContainer>
                    </ItemContainer>
                ))}
            </ResponsiveGridContainer>
        );
    }
}

Programme.defaultProps = {
    breakDowns: { 1: { count: 0, exercise: {} } },
};

const WorkoutProgrammeContent = screenWidthProvider(Programme);

export default WorkoutProgrammeContent;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/WorkoutProgramme/Content/index.js